/* eslint-disable */
import React, { useEffect, useState } from "react";
import { Redirect, Route } from "react-router-dom";
import { WithChildren } from "../../../models/shared";
import { loadState, removeState } from "../../../utils";
import { APP_ROUTES } from "../../constants/module";

const isJwtExpired = (token: string): boolean => {
  try {
    const parts = token.split(".");
    if (parts.length < 2) return true;
    const payload = JSON.parse(atob(parts[1].replace(/-/g, "+").replace(/_/g, "/")));
    if (!payload?.exp) return false;
    return Number(payload.exp) * 1000 <= Date.now();
  } catch {
    return true;
  }
};

const PrivateRoute = ({ children }: WithChildren<any>) => {
  const token = loadState();
  const [allowed, setAllowed] = useState<boolean | null>(null);

  useEffect(() => {
    if (!token || isJwtExpired(String(token))) {
      removeState();
      setAllowed(false);
      return;
    }
    setAllowed(true);
  }, [token]);

  if (allowed === null) {
    return null;
  }

  return (
    <Route
      exact
      render={() => (allowed ? children : <Redirect to={APP_ROUTES.SIGN_IN} />)}
    />
  );
};

export default React.memo(PrivateRoute);
